import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {SortEntitiesUtil} from '../sort-entities.util';

@Injectable({ providedIn: 'root' })
export class DynamicListFieldService {
  constructor(private httpClient: HttpClient) {}

  getDynamicList(url: string, sortMethod: any): Observable<Array<any>> {
    return this.httpClient.get(url).pipe(map((data: any) => this.sortDynamicList(data.content, sortMethod)));
  }

  sortDynamicList(data: any[], sortMethod: any): any[] {
    switch (sortMethod.type) {
      case 'alphabetically':
        return data.sort((a, b) => a.name.toLowerCase() - b.name.toLowerCase());

      case 'entityHierarchically':
        return SortEntitiesUtil.sortHierarchically(data);

      default:
        return data;
    }
  }
}
